import React, { Component } from 'react';
import { Editor } from '@tinymce/tinymce-react';

import withFieldWrapper from '../../hocs/withFieldWrapper';

export class EditorComponent extends Component {
    render() {
        const { input: { value }, onChange, disabled } = this.props;

        return <Editor
            value={value}
            disabled={disabled}
            onEditorChange={onChange}
            init={{
                plugins: 'link image code lists paste',
                contextmenu: 'copy paste pastetext link',
                language: 'ru',
                menubar: false,
                language_url: '/translations/ru.js',
                toolbar: 'undo redo | formatselect | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image code blockquote | removeformat',
                images_upload_handler: (info, success) => {
                    const fr = new FileReader();

                    fr.readAsDataURL(info.blob());
                    fr.onload = () => success(fr.result);
                }
            }}
            tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
        />;
    }
}

export default withFieldWrapper(EditorComponent);
